// CreateGob — the gob-type factory the Level loader and transform/build paths use.
// game/GameObjects.cpp:78-148. The C++ is a switch; here each type module SELF-REGISTERS
// its constructor (an ESM class-extends cycle forbids this module importing the derived
// classes). gob/alltypes.ts imports every type module for side effects — assemblers and
// tests import THAT. Reaching an unregistered type is a porting-order/wiring error, never
// a silent skip (the gid allocation would shift and desync everything downstream).

import type { SimContext } from '../context.ts';
import type { Gob } from './gob.ts';

const registry = new Map<number, (ctx: SimContext) => Gob>();

export function registerGobType(gt: number, make: (ctx: SimContext) => Gob): void {
  registry.set(gt, make);
}

export function CreateGob(ctx: SimContext, gt: number): Gob | null {
  const make = registry.get(gt);
  if (make === undefined) {
    throw new Error(
      `CreateGob(${gt}): gob type not registered (unported, or gob/alltypes.ts not imported)`,
    );
  }
  return make(ctx);
}
